export enum ANALYZE_ROUTE_KEYS {
  START = '',
  BROWSE = 'browse',
  VISUALIZE = 'visualize',
  EFFECTS = 'effects',
}

export const ANALYZE_ROOT_ROUTE = 'analyze';
